import { render } from "./TextTab.vue?vue&type=template&id=88caf76a"
import script from "./TextTab.vue?vue&type=script&lang=js"
export * from "./TextTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__